/**
 * One button: choose the form to read.
 *
 * It was three controls in a row — browse, upload, extract — and the person had to
 * understand which two were alternatives and which one finished the job. Choosing a
 * document is not the goal; reading it is, so the whole errand lives in one place: the
 * picker offers the library or an upload, waits for a fresh file to parse, and finishes
 * with the action that was the point.
 */
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { DocumentPicker } from "./DocumentPicker";
import { Button } from "./ui";

export function ExtractSource({
  onExtract,
  disabled = false,
  label = "select a form",
  actionLabel = "extract",
}: {
  /** The chosen document is parsed and ready; do the thing. */
  onExtract: (documentId: string) => void;
  disabled?: boolean;
  label?: string;
  actionLabel?: string;
}) {
  const client = useQueryClient();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="primary" disabled={disabled} onClick={() => setOpen(true)}>
        {label}
      </Button>

      <DocumentPicker
        open={open}
        title="Choose the form to read"
        actionLabel={actionLabel}
        onClose={() => setOpen(false)}
        onUploaded={() => {
          void client.invalidateQueries({ queryKey: ["documents"] });
          void client.invalidateQueries({ queryKey: ["jobs"] });
        }}
        onPick={() => {
          /* selection is handled inside the picker; the action closes it */
        }}
        onAction={(documentId) => {
          setOpen(false);
          onExtract(documentId);
        }}
      />
    </>
  );
}
